import { useState } from "react"
import type { FC } from "react"

interface ImageSliderProps {
  images: string[]
  onClose: () => void
}

const ImageSlider: FC<ImageSliderProps> = ({ images, onClose }) => {
  const [current, setCurrent] = useState(0)

  const prev = () => setCurrent((c) => (c === 0 ? images.length - 1 : c - 1))
  const next = () => setCurrent((c) => (c === images.length - 1 ? 0 : c + 1))

  return (
    <div role="presentation" className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center" onClick={onClose}>
      <div role="presentation" className="relative max-w-3xl w-full mx-4" onClick={(e) => e.stopPropagation()}>
        <button
          className="absolute -top-8 right-0 text-white text-lg hover:text-gray-300"
          onClick={onClose}
        >
          <i className="fa fa-times" />
        </button>
        <img src={images[current]} alt="" className="w-full h-auto max-h-[80vh] object-contain rounded" />
        {images.length > 1 && (
          <>
            <button
              className="absolute left-2 top-1/2 -translate-y-1/2 text-white text-2xl hover:text-gray-300"
              onClick={prev}
            >
              <i className="fa fa-chevron-left" />
            </button>
            <button
              className="absolute right-2 top-1/2 -translate-y-1/2 text-white text-2xl hover:text-gray-300"
              onClick={next}
            >
              <i className="fa fa-chevron-right" />
            </button>
            <div className="text-center text-white text-sm mt-2">
              {current + 1} / {images.length}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default ImageSlider